import api, { API } from "./api";

export const workflowsApi = {
  list:      () => api.get("/workflows").then((r) => r.data),
  create:    (body) => api.post("/workflows", body).then((r) => r.data),
  get:       (id) => api.get(`/workflows/${id}`).then((r) => r.data),
  update:    (id, body) => api.put(`/workflows/${id}`, body).then((r) => r.data),
  remove:    (id) => api.delete(`/workflows/${id}`).then((r) => r.data),
  duplicate: (id) => api.post(`/workflows/${id}/duplicate`).then((r) => r.data),
  validate:  (id) => api.post(`/workflows/${id}/validate`).then((r) => r.data),
  run:       (id, body) => api.post(`/workflows/${id}/run`, body).then((r) => r.data),
};

export const runsApi = {
  list:    (params = {}) => api.get("/runs", { params }).then((r) => r.data),
  summary: () => api.get("/runs/summary").then((r) => r.data),
  get:     (id) => api.get(`/runs/${id}`).then((r) => r.data),
  cancel:  (id) => api.post(`/runs/${id}/cancel`).then((r) => r.data),
  approve: (id, instructions = "") => api.post(`/runs/${id}/approve`, { decision: "approve", instructions }).then((r) => r.data),
  reject:  (id, instructions = "") => api.post(`/runs/${id}/reject`, { decision: "reject", instructions }).then((r) => r.data),
  instruct:(id, instructions) => api.post(`/runs/${id}/instruction`, { decision: "revise", instructions }).then((r) => r.data),
};

/** Open an SSE stream for a run. Returns { close }. */
export function streamRun(runId, { onEvent, onEnd }) {
  const token = localStorage.getItem("token");
  const ctrl = new AbortController();
  (async () => {
    try {
      const res = await fetch(`${API}/runs/${runId}/stream`, {
        headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        signal: ctrl.signal,
      });
      if (!res.body) return;
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const lines = buf.split("\n"); buf = lines.pop() || "";
        for (const ln of lines) {
          if (!ln.startsWith("data:")) continue;
          const payload = ln.slice(5).trim();
          if (!payload || payload === "[DONE]") continue;
          try { onEvent?.(JSON.parse(payload)); } catch {}
        }
      }
    } catch (e) {
      // aborted or network failure — silent
    } finally {
      onEnd?.();
    }
  })();
  return { close: () => ctrl.abort() };
}
